import { combineReducers } from 'redux';
import { UUID } from '../util';
import buttonOptions from './button-element-options-reducers';
import imageOptions from './image-element-options-reducers';
import searchOptions from './search-element-options-reducers';
import languageOptions from './language-element-options-reducers';
import shoppingIconOptions from './shopping-icon-element-options-reducers';
import navigationOptions from './navigation-element-options-reducers';
import socialMediaOptions from './social-media-element-options-reducers';
import dividerOptions from './divider-element-options-reducers';
import textBoxOptions from './textbox-element-options-reducers';
import logoOptions from './logo-element-options-reducers';

import {
  SET_BUTTON_ELEMENT_TEXT,
  SET_BUTTON_ELEMENT_URL,
  SET_BUTTON_ELEMENT_TARGET,
  SET_BUTTON_ELEMENT_CORNER_RADIUS,
  SET_BUTTON_ELEMENT_WIDTH,
  SET_BUTTON_ELEMENT_PADDING,

  SET_IMAGE_ELEMENT_FILE_INFO,
  SET_IMAGE_ELEMENT_URL,
  SET_IMAGE_ELEMENT_WIDTH,
  SET_IMAGE_ELEMENT_HEIGHT,
  SET_IMAGE_ELEMENT_ALIGN,

  SET_SEARCH_TEXT_WIDTH,
  SET_SEARCH_VERTICAL_PADDING,
  SET_SEARCH_TEXT_BG_COLOR,
  SET_SEARCH_TEXT_COLOR,
  SET_SEARCH_BORDER_COLOR,
  SET_SEARCH_BUTTON_STYLE,
  SET_SEARCH_BUTTON_BG_COLOR,
  SET_SEARCH_BUTTON_TEXT_ICON_COLOR,
  SET_SEARCH_BUTTON_CONTENT,
  SET_SEARCH_ICON_COLOR,
  SET_SEARCH_PLACEHOLDER_TEXT,

  LANGUAGE_SELECTOR_SELECT,
  LANGUAGE_SELECTOR_MOVE_UP,
  LANGUAGE_SELECTOR_MOVE_DOWN,
  LANGUAGE_SELECTOR_REMOVE,
  LANGUAGE_SELECTOR_SAVE,
  LANGUAGE_SELECTOR_ENABLE_FLAG,

  SET_SHOPPING_ICON_ELEMENT_FILE_INFO,
  SET_SHOPPING_ICON_ELEMENT_ICON_SIZE,
  SET_SHOPPING_ICON_ELEMENT_ICON_COLOR,
  SET_SHOPPING_ICON_ELEMENT_TEXT_COLOR,

  SET_NAVIGATION_MENU,
  SET_NAVIGATION_STYLE,
  SET_NAVIGATION_TEXT_COLOR,
  SET_NAVIGATION_TEXT_HOVER_COLOR,
  SET_NAVIGATION_ACCENT_COLOR,

  SOCIAL_MEDIA_SELECT,
  SOCIAL_MEDIA_MOVE_UP,
  SOCIAL_MEDIA_MOVE_DOWN,
  SOCIAL_MEDIA_REMOVE,
  SOCIAL_MEDIA_SAVE,
  SOCIAL_MEDIA_CHANGE_COLOR,
  SOCIAL_MEDIA_CHANGE_HOVER_COLOR,
  SOCIAL_MEDIA_CHANGE_ICON_SIZE,

  DIVIDER_CHANGE_COLOR,
  DIVIDER_CHANGE_WIDTH,
  DIVIDER_CHANGE_VERTICAL_PADDING,

  TEXTBOX_CHANGE_TEXT,

  SET_LOGO_ELEMENT_WIDTH,
  SET_LOGO_ELEMENT_HEIGHT,
  SET_LOGO_ELEMENT_LINK_HOMEPAGE,
  SET_LOGO_ELEMENT_MARGIN,
  SET_LOGO_ELEMENT_PADDING,
} from '../actions/action-names';

const category = (state = 'UNKNOWN', action) => {
  return state;
};

const id = (state = UUID(), action) => {
  switch (action.type) {
    default:
      return state;
  }
};

const type = (state = 'unknown', action) => {
  switch (action.type) {
    default:
      return state;
  }
};

const caption = (state = 'Untitled', action) => {
  switch (action.type) {
    default:
      return state;
  }
};

const options = (state = {}, action) => {
  switch (action.type) {
    case SET_BUTTON_ELEMENT_TEXT:
    case SET_BUTTON_ELEMENT_URL:
    case SET_BUTTON_ELEMENT_TARGET:
    case SET_BUTTON_ELEMENT_CORNER_RADIUS:
    case SET_BUTTON_ELEMENT_WIDTH:
    case SET_BUTTON_ELEMENT_PADDING:
      return buttonOptions(state, action);

    case SET_IMAGE_ELEMENT_FILE_INFO:
    case SET_IMAGE_ELEMENT_URL:
    case SET_IMAGE_ELEMENT_WIDTH:
    case SET_IMAGE_ELEMENT_HEIGHT:
    case SET_IMAGE_ELEMENT_ALIGN:
      return imageOptions(state, action);

    case SET_SEARCH_TEXT_WIDTH:
    case SET_SEARCH_VERTICAL_PADDING:
    case SET_SEARCH_TEXT_BG_COLOR:
    case SET_SEARCH_TEXT_COLOR:
    case SET_SEARCH_BORDER_COLOR:
    case SET_SEARCH_BUTTON_STYLE:
    case SET_SEARCH_BUTTON_BG_COLOR:
    case SET_SEARCH_BUTTON_TEXT_ICON_COLOR:
    case SET_SEARCH_BUTTON_CONTENT:
    case SET_SEARCH_ICON_COLOR:
    case SET_SEARCH_PLACEHOLDER_TEXT:
      return searchOptions(state, action);

    case LANGUAGE_SELECTOR_SELECT:
    case LANGUAGE_SELECTOR_MOVE_UP:
    case LANGUAGE_SELECTOR_MOVE_DOWN:
    case LANGUAGE_SELECTOR_REMOVE:
    case LANGUAGE_SELECTOR_SAVE:
    case LANGUAGE_SELECTOR_ENABLE_FLAG:
      return languageOptions(state, action);

    case SET_SHOPPING_ICON_ELEMENT_FILE_INFO:
    case SET_SHOPPING_ICON_ELEMENT_ICON_SIZE:
    case SET_SHOPPING_ICON_ELEMENT_ICON_COLOR:
    case SET_SHOPPING_ICON_ELEMENT_TEXT_COLOR:
      return shoppingIconOptions(state, action);

    case SET_NAVIGATION_MENU:
    case SET_NAVIGATION_STYLE:
    case SET_NAVIGATION_TEXT_COLOR:
    case SET_NAVIGATION_TEXT_HOVER_COLOR:
    case SET_NAVIGATION_ACCENT_COLOR:
      return navigationOptions(state, action);

    case SOCIAL_MEDIA_SELECT:
    case SOCIAL_MEDIA_MOVE_UP:
    case SOCIAL_MEDIA_MOVE_DOWN:
    case SOCIAL_MEDIA_REMOVE:
    case SOCIAL_MEDIA_SAVE:
    case SOCIAL_MEDIA_CHANGE_COLOR:
    case SOCIAL_MEDIA_CHANGE_HOVER_COLOR:
    case SOCIAL_MEDIA_CHANGE_ICON_SIZE:
      return socialMediaOptions(state, action);

    case DIVIDER_CHANGE_COLOR:
    case DIVIDER_CHANGE_WIDTH:
    case DIVIDER_CHANGE_VERTICAL_PADDING:
      return dividerOptions(state, action);

    case TEXTBOX_CHANGE_TEXT:
      return textBoxOptions(state, action);

    case SET_LOGO_ELEMENT_WIDTH:
    case SET_LOGO_ELEMENT_HEIGHT:
    case SET_LOGO_ELEMENT_LINK_HOMEPAGE:
    case SET_LOGO_ELEMENT_MARGIN:
    case SET_LOGO_ELEMENT_PADDING:
      return logoOptions(state, action);

    default:
      return state;
  }
};

export default combineReducers({
  category,
  id,
  type,
  caption,
  options
});



// WEBPACK FOOTER //
// ./app/header-builder/reducers/element-reducers.js